import React from 'react';
import { Coffee } from 'lucide-react';
export function Footer() {
  return <footer className="bg-espresso-900 text-cream-200/60 py-12 px-4 border-t border-espresso-800" data-id="element-55">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-56">
        <Coffee className="w-8 h-8 text-gold-500 mb-6 opacity-50" data-id="element-57" />

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm" data-id="element-58">
          <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-59">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-60">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-61">
            Contacto
          </a>
        </div>

        <p className="text-sm" data-id="element-62">
          © {new Date().getFullYear()} El Arte del Café. Todos los derechos
          reservados.
        </p>
        <p className="text-xs mt-4 max-w-2xl opacity-50" data-id="element-63">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}